import { Button } from "../../../components/ui/button";

interface OptionBadgeProps {
	onSelect: () => void;
	value: string;
	selected: boolean;
}

function OptionBadge({ onSelect, value, selected }: OptionBadgeProps) {
	return (
		<Button
			type="button"
			variant={selected ? "outlinePrimary" : "outlineSecondary"}
			aria-pressed={selected}
			className="rounded-full"
			onClick={onSelect}
		>
			{value}
		</Button>
	);
}

export default OptionBadge;
